<template>
  <div>
    <b-button-group class="search-box-button-group" v-if="!hideCompanyTypeToggle">
      <button @click="companyButton()" v-bind:class="[getCompanyButtonClass]" class="btn corpotation-button">
        Cégkereső
      </button>
      <!--button @click="companyButton()" v-bind:class="[getCompanyButtonClass]" class="btn corpotation-button">
        Társas vállalkozás
      </button>
      <button
        @click="soleProprietorshipButton()"
        v-bind:class="[getSoleProprietorshipButtonClass]"
        class="btn individual-button"
      >
        Egyéni vállalkozás
      </button-->
    </b-button-group>

    <div
      class="search-box-wrapper"
      v-bind:class="[{ 'kkv-qualifier-minus-margin': currentPageKkvQualifier }, getBackgroundState]"
    >
      <label class="text-left" v-if="currentPage == 'kkv-qualifier'">Keresés</label>
      <div></div>
      <div>
        <vue-autosuggest
          v-if="isSearchCompany"
          :suggestions="getCompanySuggestionsFormatted"
          :input-props="{
            type: 'search',
            id: 'autosuggest__input',
            placeholder: 'Keresés cégnév szerint'
          }"
          :get-suggestion-value="getSuggestionValue"
          @input="onInputChange"
          @selected="selectCompanyHandler"
        >
          <template v-if="hideCompanyTypeToggle" slot="before-input">
            <label class="company-select-label" for="autosuggest__input">Társas vállalkozás kiválasztása</label>
          </template>

          <template slot-scope="{ suggestion }">
            <span class="my-suggestion-item">{{ getSafeCompanyName(suggestion.item) }} </span>
          </template>
        </vue-autosuggest>

        <vue-autosuggest
          v-else
          v-bind:class="[getMoreResultsClass]"
          :suggestions="getSuggestions"
          :input-props="{
            type: 'search',
            id: 'autosuggest__input',
            placeholder: 'Keresés egyéni vállalkozásra'
          }"
          :get-suggestion-value="getSuggestionValue"
          @input="onInputChange"
          @selected="selectSoleProprietorshipHandler"
        >
          <template slot-scope="{ suggestion }">
            <span class="my-suggestion-item"> {{ getSuggestionName(suggestion) }} </span>
          </template>
        </vue-autosuggest>
      </div>

      <div class="mt-4 mb-4 text-center" v-if="showNoResult && !getTooManyResultStatus && !getUserRateLimitedStatus">
        <not-found-svg />
        <p style="font-size: 20px" class="mt-2">Sajnos nem találtunk ilyen nevű céget</p>
        <p>Próbálja meg pontosan megadni cége nevét</p>
      </div>

      <div class="mt-4 mb-4 text-center" v-if="getUserRateLimitedStatus && !getTooManyResultStatus">
        <rate-limit-svg />
        <p style="font-size: 20px" class="mt-2">Sajnos túllépte a napi keresési limitet.</p>
        <p>Később próbálja meg újra.</p>
      </div>

      <div class="mt-4 mb-4 text-center" v-if="getTooManyResultStatus">
        <rate-limit-svg />
        <p style="font-size: 20px" class="mt-2">Túl sok találat</p>
        <p>Kérjük a keresési kulcsszó bővítésével pontosítsa a keresett vállalkozás nevét</p>
      </div>

      <div class="text-center">
        <b-spinner v-if="isLoading" class="mt-5"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest'
import { mapGetters } from 'vuex'
import NotFoundSvg from './svg/SearchCompany/NotFound'
import RateLimitSvg from './svg/SearchCompany/RateLimit'

export default {
  props: ['currentPage', 'hideCompanyTypeToggle'],
  data() {
    return {
      searchTerm: '',
      selectedCompany: null,
      selectedProprietorshipSuggestion: null,
      timeout: null
    }
  },
  name: 'SearchCompany',
  components: {
    VueAutosuggest,
    NotFoundSvg,
    RateLimitSvg
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'isSearchCompany',
      'companySuggestions',
      'soleProprietorshipSuggestions',
      'getUserRateLimitedStatus',
      'getTooManyResultStatus'
    ]),

    // --- JAVÍTÁS KEZDETE ---
    // Ez a computed property formázza meg helyesen az adatot a vue-autosuggest számára
    getCompanySuggestionsFormatted() {
      // 1. Biztonságos hozzáférés a nyers adatokhoz
      let rawData = []

      if (this.companySuggestions) {
        if (Array.isArray(this.companySuggestions)) {
          // Ha a store közvetlenül tömböt ad vissza (pl. parseQuickSearchResponseList eredménye)
          rawData = this.companySuggestions
        } else if (this.companySuggestions.data && Array.isArray(this.companySuggestions.data)) {
          // Ha a store { data: [...] } formában tárol
          rawData = this.companySuggestions.data
        }
      }

      // 2. Visszaadjuk abban a formátumban, amit a komponens vár: [{ data: [...] }]
      return [
        {
          data: rawData
        }
      ]
    },
    // --- JAVÍTÁS VÉGE ---

    showNoResult() {
      if (this.isSearchCompany) {
        // Itt is érdemes biztonságosabb ellenőrzést használni
        const hasData =
          this.companySuggestions &&
          ((Array.isArray(this.companySuggestions) && this.companySuggestions.length > 0) ||
            (this.companySuggestions.data && this.companySuggestions.data.length > 0))

        return !hasData && this.searchTerm.length >= 3 && !this.isLoading
      } else {
        return !this.soleProprietorshipSuggestions.data.length && this.searchTerm.length >= 3 && !this.isLoading
      }
    },
    currentPageKkvQualifier() {
      return this.currentPage == 'kkv-qualifier' ? true : false
    },
    currentPageFundMap() {
      return this.$route.path === '/fund-map'
    },
    getBackgroundState() {
      if (this.getUserRateLimitedStatus || this.getTooManyResultStatus) return 'bg-color-lightred'
      if (this.searchTerm.length == 0 || this.searchTerm.length < 3) return 'bg-color-lightblue'
      if (this.searchTerm.length >= 3 && this.isLoading) return 'bg-color-lightgreen'
      return this.showNoResult && !this.isLoading ? 'bg-color-lightred' : 'bg-color-lightgreen'
    },
    getCompanyButtonClass() {
      if (this.isSearchCompany) {
        return 'active-search-button'
      }
      return 'non-active-search-button'
    },
    getSoleProprietorshipButtonClass() {
      if (!this.isSearchCompany) {
        return 'active-search-button'
      }
      return 'non-active-search-button'
    },
    checkIsSearchCompany() {
      if (!this.isSearchCompany) {
        return false
      }
      return true
    },
    getSuggestions() {
      const suggestions = {
        data: [
          ...(this.soleProprietorshipSuggestions.data.length > 5
            ? this.soleProprietorshipSuggestions.data.slice(0, 5)
            : this.soleProprietorshipSuggestions.data)
        ]
      }
      if (suggestions.data.length === 5) {
        suggestions.data.push('További találatok...')
      }
      return [suggestions]
    },
    getMoreResultsClass() {
      if (this.soleProprietorshipSuggestions.data.length >= 5) {
        return 'more-result'
      }
      return ''
    }
  },
  methods: {
    getSafeCompanyName(item) {
      if (!item) return ''
      // Ha már string (pl. "További találatok...")
      if (typeof item === 'string') return item

      // Ha tömb (pl. Bisnode/Opten struktúra: [{name: 'Cégnév', language: 'hu'}])
      if (Array.isArray(item.name)) {
        return item.name[0]?.name || ''
      }
      // Ha sima string a név
      return item.name || ''
    },
    async onSearchSubmit(company) {
      if (!company) {
        console.error('Nincs company paraméter')
        return
      }
      // Vue reaktív réteg leszedése
      company = JSON.parse(JSON.stringify(company))

      const companyId =
        typeof company.full_tax_number === 'string'
          ? company.full_tax_number
          : typeof company.id === 'string' || typeof company.id === 'number'
          ? String(company.id)
          : ''

      if (!companyId || !/^\d{8,11}$/.test(companyId)) {
        console.error('Érvénytelen companyId', company)
        return
      }

      const getCompanyQueryParams = { value: companyId }
      await this.$store.dispatch('getCompany', getCompanyQueryParams)

      if (this.currentPageKkvQualifier) {
        this.$router.push({
          path: 'add-company-private',
          query: { companyId, redir: 'kkv-result' }
        })
      } else {
        this.$router.push({ path: 'company-details', query: { companyId } })
      }
      await this.$store.dispatch('nullifyCompanySuggestionsAction')
      await this.$store.dispatch('nullifySoleProprietorShipSuggestionsAction')
    },
    async onSoleProprietorshipSearchSubmit() {
      if (typeof this.selectedProprietorshipSuggestion === 'string') {
        this.$store.commit('setSoleProprietorshipSearchTerm', this.searchTerm)
        this.$router.push('sole-proprietorship-more-details')
      } else {
        const getSoleProprietorshipQueryParams = {
          value: this.selectedProprietorshipSuggestion.id
        }
        await this.$store.dispatch('getSoleProprietorship', getSoleProprietorshipQueryParams)
        this.$router.push({
          name: 'SoleProprietorshipDetails',
          query: { soleProprietorshipId: this.selectedProprietorshipSuggestion.id }
        })
      }
      await this.$store.dispatch('nullifyCompanySuggestionsAction')
      await this.$store.dispatch('nullifySoleProprietorShipSuggestionsAction')
    },
    async selectCompanyHandler(suggestion) {
      // 🔥 A NYERS találat kinyerése
      const raw = suggestion?.item?.value || suggestion?.item || suggestion?.value || suggestion
      const company = JSON.parse(JSON.stringify(raw)) // Vue reaktív réteg leszedése

      const companyId = company.full_tax_number || company.id
      if (!companyId) {
        console.error('Érvénytelen companyId (nincs full_tax_number/id)', company)
        return
      }
      await this.onSearchSubmit(company)
    },
    async selectSoleProprietorshipHandler(suggestion) {
      this.selectedProprietorshipSuggestion = suggestion.item
      await this.onSoleProprietorshipSearchSubmit()
    },
    async onInputChange(text) {
      await this.$store.dispatch('nullifyCompanySuggestionsAction')
      await this.$store.dispatch('nullifySoleProprietorShipSuggestionsAction')
      await this.$store.dispatch('tooManyResult', false)
      this.searchTerm = text
      var isSearchCompany = this.isSearchCompany

      if (text.length >= 3) {
        let _this = this
        clearTimeout(this.timeout)
        this.timeout = setTimeout(async function() {
          await _this.$recaptchaLoaded()
          const recaptchaToken = await _this.$recaptcha('search')
          const searchQueryParams = { search: _this.searchTerm, limit: 5, recaptchaToken }

          if (isSearchCompany) {
            _this.$store.dispatch('searchCompanies', searchQueryParams)
          } else {
            _this.$store.dispatch('searchSoleProprietorship', searchQueryParams)
          }
        }, 500)
      }
    },
    getSuggestionValue(suggestion) {
      if (typeof suggestion.item === 'string') {
        return suggestion.item
      }
      return this.getSafeCompanyName(suggestion.item)
    },
    getSuggestionName(suggestion) {
      if (typeof suggestion.item === 'string') {
        return suggestion.item
      }
      const rawName = this.getSafeCompanyName(suggestion.item)
      const name = rawName
        .split(' ')
        .map(name => {
          const lowerCaseName = name.toLowerCase()
          return lowerCaseName.charAt(0).toUpperCase() + lowerCaseName.slice(1)
        })
        .join(' ')

      let addressStr = ''
      if (suggestion.item.address) {
        if (typeof suggestion.item.address === 'string') {
          addressStr = suggestion.item.address
        } else if (suggestion.item.address.Zip) {
          // Ide jöhet a saját objektum-cím logikád, ha van
          addressStr = `${suggestion.item.address.Zip} ${suggestion.item.address.City}`
        }
      }

      let postCode = ''
      let location = ''
      if (addressStr.length >= 4) {
        postCode = addressStr.slice(0, 4)
        let locPart = addressStr.slice(4).split(',')[0]
        if (locPart) {
          location = locPart.toLowerCase()
          location = location.charAt(1).toUpperCase() + location.slice(2)
        }
      }

      return `${name} - ${suggestion.item.id || suggestion.item.full_tax_number} - ${postCode}, ${location}`
    },
    companyButton() {
      this.$store.commit('setIsSearchCompany', true)
    },
    soleProprietorshipButton() {
      this.$store.commit('setIsSearchCompany', false)
    }
  },
  mounted() {
    this.$store.commit('setIsSearchCompany', true)
  }
}
</script>

<style>
.search-box-button-group {
  width: 100% !important;
  height: 80px;
}
.search-box-button-group button {
  height: auto;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-style: none;
  font-weight: bold;
}
.non-active-search-button {
  background-color: var(--color-lightblue);
  color: var(--color-green);
}
.non-active-search-button:hover {
  color: var(--color-green);
  background-color: #dde7eb !important;
}
.active-search-button {
  cursor: auto;
  pointer-events: none;
  background-color: var(--color-green);
  color: #ffffff;
}
.active-search-button:hover {
  background-color: var(--color-green) !important;
  color: #ffffff !important;
}
.active-search-button:focus {
  box-shadow: none;
}
.search-box-wrapper {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 32px;
}
.kkv-qualifier-minus-margin {
  margin-left: -30px;
  margin-right: -30px;
}
@media (max-width: 993px) {
  .search-box-wrapper {
    padding: 8px !important;
  }
}
#autosuggest-autosuggest__results {
  position: relative;
}
#autosuggest__input.autosuggest__input--open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #00903c;
}
#autosuggest__input {
  caret-color: #ddd;
  position: relative;
  display: block;
  border: 0px solid #00903c;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  margin: 0 auto;
  width: 100%;
  height: 80px;
  font-size: 24px;
  color: var(--color-gray-05);
}
#autosuggest__input::before {
  position: absolute;
  display: inline-block;
  background-size: 14px 14px;
  height: 14px;
  width: 14px;
  content: ' ';
  margin-left: 100px;
  top: 2px;
  background-image: url('../assets/img/icons/Success.svg');
}
#autosuggest__input ::-webkit-input-placeholder {
  color: var(--color-gray-04);
}
#autosuggest__input :-moz-placeholder {
  color: var(--color-gray-04);
  opacity: 1;
}
#autosuggest__input::-moz-placeholder {
  color: var(--color-gray-04);
  opacity: 1;
}
#autosuggest__input:-ms-input-placeholder {
  color: var(--color-gray-04);
}
#autosuggest__input::-ms-input-placeholder {
  color: var(--color-gray-04);
}
.kkvAutoSuggest > div > #autosuggest__input ::-webkit-input-placeholder {
  color: red !important;
  font-weight: bold;
}
#autosuggest__input::placeholder {
  color: var(--color-gray-04);
  opacity: 0.7;
}
.kkvAutoSuggest ::placeholder {
  color: white !important;
  font-weight: normal;
}
.search-input-icon {
  border-bottom-right-radius: 15px;
  border-top-right-radius: 15px;
}
.autosuggest__results {
  background-color: white;
  font-weight: 300;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 0px;
  overflow: none;
  max-height: 650px;
  color: var(--color-body);
  font-size: 22px;
}
.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
  padding-top: 0px;
  padding-bottom: 0px;
}
.autosuggest__results li {
  padding-left: 15px;
  padding-right: 15px;
  padding: 20px;
}
.more-result li:last-child {
  background-color: #cde7eb !important;
  font-weight: 700;
}
.autosuggest__results li:hover {
  background-color: var(--color-lightgreen);
  cursor: pointer;
}
.company-select-label {
  width: 100%;
  font-size: 14px;
}
</style>
